export default "__VITE_ASSET__CgJDJKm___"